import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardHeader,
  Badge,
  Typography,
  CardActions,
  Button,
  CardContent,
  VaporIcon,
} from "@vapor/v3-components";

interface ResponsiveCardProps {
  content: string;
  image: string;
  numDoc: number;
  width: number; // Larghezza della card calcolata dinamicamente
  onClick: () => void;
}

export const ResponsiveCard: React.FC<ResponsiveCardProps> = ({
  content,
  image,
  numDoc,
  width,
  onClick,
}) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  useEffect(() => {
    // Fetch del file SVG dal server
    fetch(image)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load SVG: ${response.statusText}`);
        }
        return response.text();
      })
      .then((data) => {
        // Inserisce il contenuto dell'SVG nel componente
        setSvgContent(data);
      })
      .catch((error) => {
        console.error("Error loading SVG:", error);
        setSvgContent(null);
      });
  }, [image]);

  return (
    <Card
      variant="outlined"
      sx={{
        width: `${width}px`, // Imposta la larghezza dinamica
        height: "120px",
        margin: "0 auto", // Centra la card
        backgroundColor: "strateLayer1",
        //     transition: "background-color 0.3s", // Per rendere fluido il cambio di colore
        "&:hover": {
          borderColor: "#0076AD !important", // Cambia colore tutta la card
        },
        // // Garantiamo che anche i figli non abbiano un'area separata
        // "&:hover .MuiCardActions-root, &:hover .MuiCardActionArea-root, &:hover .MuiCardMedia-root":
        //   {
        //     backgroundColor: "rgba(0, 0, 0, 0.1)", // In caso vogliamo propagare
        //   },
      }}
    >
      <CardContent>
        <CardActionArea
          sx={{
            backgroundColor: "strateLayer1",
          }}
          onClick={() => onClick()}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingRight: 3,
              paddingBottom: 2,
              // p: 2,
            }}
          >
            {svgContent ? (
              <CardMedia
                component="div"
                sx={{
                  height: "40px", // Altezza dell'icona
                  display: "inline-block",
                  "& svg": {
                    fill: "#212020", // Cambia il colore usando la proprietà fill
                    width: "100%",
                    height: "100%",
                  },
                }}
                dangerouslySetInnerHTML={{ __html: svgContent }}
              />
            ) : (
              <p>Loading icon...</p>
            )}
            <Badge
              badgeContent={numDoc}
              max={9999}
              size="medium"
              sx={{
                mt: 0,
              }}
              variant="standard"
              //          color="info"
              color="counter"
            />
          </Box>
          <Box
          // sx={{ p: 2 }}
          >
            <Typography
              color="#101214"
              mb={1}
              variant="bodyInterfaceLargeHeavy"
            >
              {content}
            </Typography>
          </Box>
        </CardActionArea>
      </CardContent>
    </Card>
  );
};
